import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../../utils/api';

const BlogPostView = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    api.get(`/api/blog/post/${slug}`)
      .then(res => {
        if (!cancelled) {
          setPost(res.data.post);
          setError(null);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err.response?.status === 404 ? 'Post not found' : (err.response?.data?.error || 'Failed to load post'));
          setPost(null);
        }
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="min-h-screen bg-gray-50 py-8 px-4">
        <div className="max-w-3xl mx-auto">
          <p className="text-red-600 bg-red-50 p-4 rounded-lg">{error || 'Post not found'}</p>
          <Link to="/blog" className="inline-block mt-4 text-blue-600 hover:text-blue-800">← Back to Blog</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/blog" className="text-blue-600 hover:text-blue-800 text-sm font-medium mb-4 inline-block">← Back to Blog</Link>
        <article className="bg-white rounded-lg border border-gray-200 p-6 md:p-8">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">{post.title}</h1>
          <p className="text-gray-500 mt-2">
            {post.authorName}
            {post.publishedAt && (
              <span className="ml-2">· {new Date(post.publishedAt).toLocaleDateString()}</span>
            )}
          </p>
          <div className="mt-6 prose prose-gray max-w-none whitespace-pre-wrap text-gray-700">{post.body}</div>
        </article>
      </div>
    </div>
  );
};

export default BlogPostView;
